var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-70.7413 134.655C-12.5696 67.8478 102.308 154.275 268.76 116.451C412.926 83.674 421.22 -3.38671 536.407 0.9305C620.56 4.06791 712.261 52.6589 762.658 137.312C818.236 230.65 798.032 325.674 792.361 348.732C767.043 452.159 691.897 506.717 665.387 525.351C556.164 602.077 433.602 588.632 374.803 582.211C153.935 558.021 -82.5249 400.334 -93.0535 228.897C-94.4528 206.452 -96.9995 164.823 -70.7413 134.655Z",
  fill: "#FF725E",
  fillOpacity: 0.2
});

function SvgCustomBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90%",
    height: 500,
    viewBox: "0 0 600 1088",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBlob);
export default __webpack_public_path__ + "static/media/custom-blob.17f2e06511baf1f9d133d8c71d292d14.svg";
export { ForwardRef as ReactComponent };